"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bboxStyleDefault = void 0;
exports.bboxStyleDefault = {
    pointWidthPx: 8,
    pointOpacity: 0.75,
    borderWidthPx: {
        notSelected: 2,
        selected: 3
    },
    boxShadowWidthPx: 0,
    borderColorSLA: {
        notSelected: [80, 50, 1],
        selected: [100, 80, 1]
    },
    highlightedFaceColorSLA: [80, 50, 0.4],
    borderDashLengthPx: 5
};
